/**
 * Resolves a relative image URL (e.g. /uploads/photo.jpg) to a loadable URL.
 * - In dev: uses relative path so Vite proxy forwards to backend
 * - In prod: prepends VITE_API_URL when set (for cross-origin backend)
 */
export function resolveImageUrl(url: string | null | undefined): string {
	if (!url) {
		return "";
	}
	if (url.startsWith("http://") || url.startsWith("https://")) {
		return url;
	}
	const path = url.startsWith("/") ? url : `/${url}`;
	// In dev, use relative path so proxy (/uploads -> backend) works
	if (import.meta.env.DEV) {
		return path;
	}
	const base = import.meta.env.VITE_API_URL ?? "";
	const baseClean = base.endsWith("/") ? base.slice(0, -1) : base;
	return baseClean ? `${baseClean}${path}` : path;
}
